import type { MonthProgress } from './monthProgress'

export function MonthHeader({ today, progress }: { today: Date; progress: MonthProgress }) {
  const title = today.toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })
  const left =
    progress.daysLeft === 0
      ? 'last day'
      : `${progress.daysLeft} day${progress.daysLeft === 1 ? '' : 's'} left`

  return (
    <header
      className={
        "grid grid-cols-[1fr_auto] items-baseline gap-x-3 pb-3 [grid-template-areas:'title_day'_'bar_bar'] " +
        "lg:grid-cols-[1fr_300px] lg:items-center lg:pb-4 lg:[grid-template-areas:'title_bar'_'title_day']"
      }
    >
      <h2 className="font-serif text-xl font-semibold tracking-tight text-[var(--fl-heading)] [grid-area:title] lg:text-[30px] lg:leading-[38px]">
        {title}
      </h2>
      <div
        className="mt-2 h-1 overflow-hidden rounded bg-[var(--fl-border)] [grid-area:bar] lg:mt-0 lg:self-end"
        aria-hidden="true"
      >
        <div
          className="h-1 rounded bg-[var(--fl-primary)]"
          style={{ width: `${progress.pacePercent}%` }}
        />
      </div>
      <p className="text-xs text-[var(--fl-text-2)] [grid-area:day] lg:mt-2 lg:self-start lg:text-right lg:text-[13px]">
        Day {progress.day} of {progress.daysInMonth} · {left}
      </p>
    </header>
  )
}
